import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import MainTitle from 'base/components/MainTitle';
import Header from 'base/components/Header';
import { getAuthUserId, getIsAdmin } from 'auth/store/auth/selectors';
import { getActiveStateAuditPendingRoles } from 'auth/store/audit/selectors';
import { getManagePermissionsIsLoading } from 'auth/store/permissions/selectors';
import HeaderMessage from 'base/components/HeaderMessage';
import NavLink from 'base/components/NavLink';
import { fetchAllSpaceRoles } from 'auth/store/roles/actions';
import { fetchAuditPendingRoleIdsForSpaceId } from 'auth/store/audit/actions';
import { useMatch } from 'react-router';
import { getActiveSpace } from '../store/selectors';

const SpacePermissionsEntry = ({
  space,
  rolesPendingAudit,
  fetchAllSpaceRoles,
  fetchAuditPendingRoleIdsForSpaceId,
}) => {
  const match = useMatch('/spaces/:spaceId/permissions/*');
  const spaceId = match?.params?.spaceId;
  useEffect(() => {
    fetchAllSpaceRoles(spaceId);
    fetchAuditPendingRoleIdsForSpaceId(spaceId);
  }, [fetchAllSpaceRoles, fetchAuditPendingRoleIdsForSpaceId, spaceId]);
  const auditLinks =
    rolesPendingAudit.length > 0 ? (
      <ul>
        {rolesPendingAudit.map(role => (
          <li key={role.id}>
            <NavLink to={`/spaces/${space.id}/permissions/${role.id}`}>{role.name}</NavLink>
          </li>
        ))}
      </ul>
    ) : (
      []
    );
  return (
    <>
      <Header>
        <MainTitle>
          Space {space && space.name} permissions
          <br />
          Choose a role on the left.
        </MainTitle>
      </Header>

      {space &&
        space.needsRoleAudit &&
        space.auditDeadline &&
        (new Date(space.auditDeadline) < new Date() ? (
          <HeaderMessage
            type="warning"
            title="Role review deadline expired"
            message={
              <div>
                <p>
                  <strong>
                    Corresponding users/roles have been blocked from this space.
                    <br />
                  </strong>
                  Please review the permissions below to allow all users to access this space again.
                  <br />
                </p>
                {auditLinks}
              </div>
            }
          />
        ) : (
          <HeaderMessage
            type="warning"
            title="Role review required"
            message={
              <div>
                <p>
                  Please review the permissions below until&nbsp;
                  {dayjs(space.auditDeadline).format('DD.MM.YYYY')}
                  &nbsp;, or all users will be blocked from accessing this space.
                  <br />
                </p>
                {auditLinks}
              </div>
            }
          />
        ))}
    </>
  );
};
SpacePermissionsEntry.propTypes = {
  space: PropTypes.objectOf(PropTypes.any).isRequired,
  isAdmin: PropTypes.bool.isRequired, // eslint-disable-line
  myUserId: PropTypes.number.isRequired, // eslint-disable-line
  rolesPendingAudit: PropTypes.arrayOf(PropTypes.object).isRequired,
  fetchAllSpaceRoles: PropTypes.func.isRequired,
  fetchAuditPendingRoleIdsForSpaceId: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  space: getActiveSpace(state),
  isLoading: getManagePermissionsIsLoading(state),
  isAdmin: getIsAdmin(state),
  myUserId: getAuthUserId(state),
  rolesPendingAudit: getActiveStateAuditPendingRoles(state),
});

const mapDispatchToProps = {
  fetchAllSpaceRoles,
  fetchAuditPendingRoleIdsForSpaceId,
};

export default connect(mapStateToProps, mapDispatchToProps)(SpacePermissionsEntry);
